export class CAIXAFECHADO {
    EMP: string; 
    ID_CAIXA:string; 
    AGENCIA:string; 
    DATA_FECHAMENTO: string; 
    BOTAO:string;
 }